// Toggle for the son-collapsible-text widget (see Son_Collapsible_Text).
//
// MARKUP CONTRACT
//   <div class="son-collapsible-text is-collapsed">
//     <button class="son-collapsible-text__toggle" aria-expanded="false" aria-controls="{body-id}">
//     <div class="son-collapsible-text__body" id="{body-id}">…</div>
//   </div>
//
// Open/close animation is pure CSS; JS only toggles .is-collapsed and
// aria-expanded.

function bindCollapsibleTexts(root = document) {
    root.querySelectorAll('.son-collapsible-text__toggle').forEach((button) => {
        if (button.dataset.sonCollapsibleReady) {
            return;
        }
        button.dataset.sonCollapsibleReady = 'true';

        button.addEventListener('click', () => {
            const widget = button.closest('.son-collapsible-text');
            const collapsed = widget.classList.toggle('is-collapsed');
            button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });
    });
}

document.addEventListener('DOMContentLoaded', () => bindCollapsibleTexts());

// re-bind after Elementor editor re-renders an element
window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', ($element) => {
            bindCollapsibleTexts($element[0] || document);
        });
    }
});
